import type { NotificationResponseBasicInfo } from './notificationResponseBasicInfo';
import type { NotificationResponseData } from './notificationResponseData';
import type { NotificationResponseSource } from './notificationResponseSource';
import type { NotificationResponseStatus } from './notificationResponseStatus';
import type { NotificationResponseTarget } from './notificationResponseTarget';

/**
 * 알림 응답 데이터
 */
export interface NotificationResponse {
  basicInfo?: NotificationResponseBasicInfo;
  /** 알림 추가 데이터 (유형에 따라 다름) */
  data?: NotificationResponseData;
  /** 알림 소스 정보 */
  source?: NotificationResponseSource;
  /** 알림 상태 정보 */
  status?: NotificationResponseStatus;
  /** 알림 대상 정보 */
  target?: NotificationResponseTarget;
}
